import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	templateUrl: './errors_details.component.html'
})
export class ErrorsDetailsComponent extends InfoModalComponent {
	details;
	type = 'users';

	ok() {
		this.close();
	}
}
